import { useState } from 'react'
import { useNewPassword } from '@/v2/hooks/auth/useAuthentication'
import { useSnackbarContext } from '@/v2/contexts/SnackbarContext'
import { useNavigate } from 'react-router-dom'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'

const resetPasswordSchema = yup.object({
  email: yup
    .string()
    .email('Invalid email address')
    .required('Email is required'),
})

export const useNewPasswordForm = () => {
  const navigate = useNavigate()
  const { newPassword, isLoading } = useNewPassword()
  const { onOpenSnackbar } = useSnackbarContext()

  const [values, setValues] = useState({
    email: '',
  })
  const [errors, setErrors] = useState({})

  const {
    register,
    formState: { isSubmitting },
  } = useForm({
    mode: 'onSubmit',
    resolver: yupResolver(resetPasswordSchema),
    defaultValues: values,
  })

  const handleNewPassword = async () => {
    const newPwdBody = {
      session: {
        email: values.email,
      },
    }
    await newPassword(newPwdBody, {
      onSuccess: data => {
        navigate('/v2/login')
        onOpenSnackbar(data.message, 'success')
      },
      onError: error => {
        onOpenSnackbar(`${error}`, 'error')
      },
    })
  }

  const handleSubmitForm = async () => {
    try {
      await resetPasswordSchema.validate(values, { abortEarly: false })
      setErrors({})
      await handleNewPassword()
    } catch (validationError) {
      const fieldErrors = {}
      if (validationError.inner && validationError.inner.length > 0) {
        validationError.inner.forEach(err => {
          if (!fieldErrors[err.path]) {
            fieldErrors[err.path] = err.message
          }
        })
      } else {
        fieldErrors[validationError.path] = validationError.message
      }
      setErrors(fieldErrors)
    }
  }

  return {
    values,
    errors,
    isLoading,
    isSubmitting,
    register,
    setValues,
    handleSubmitForm,
  }
}
